import {StreamItem_EndOfStreamSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coupons/v1/landingpage/service.types';
import {useParams} from '@aboutyou/router';
import {
  useTrackFeature,
  useTrackFeatureInViewImpression,
} from '@aboutyou/tracking';
import {ProductTileEndOfStreamWithCTA} from '@aboutyou/ui-components';
import React from 'react';

const FEATURE_TRACKING_NAME = 'end_of_stream_element';

export const EndOfStreamWithCTA: React.FC<{
  endOfStream: StreamItem_EndOfStreamSection;
}> = ({endOfStream}) => {
  const trackFeature = useTrackFeature();
  const {promotionId} = useParams();
  const {headline, cta, subline} = endOfStream;

  const featureTrackingData = {
    name: FEATURE_TRACKING_NAME,
    label: promotionId,
  };

  const {ref} =
    useTrackFeatureInViewImpression<HTMLDivElement>(featureTrackingData);

  const onCTAClick = () => {
    trackFeature({
      eventType: 'click',
      ...featureTrackingData,
    });
  };

  return (
    <div ref={ref}>
      <ProductTileEndOfStreamWithCTA
        headline={headline}
        subline={subline}
        cta={cta}
        onCTAClick={onCTAClick}
      />
    </div>
  );
};
